import { useEffect, useState } from "react";
import { getProjectDetailsDataApi } from "../api/project";
import { getContractorsApi, getMembersApi } from "../api/member";

export function useProject(projectId) {
  const [project, setProject] = useState();

  useEffect(() => {
    if (projectId) {
      getProjectInfo();
    }
  }, [projectId]);

  const getProjectInfo = async () => {
    const response = await getProjectDetailsDataApi(projectId);
    const members = await getMembersApi(projectId);
    const contractors = await getContractorsApi(projectId);
    if (response?.data?.length) {
      setProject({ ...response.data[0], members: members ? members.data : [], contractors: contractors ? contractors.data : [] });
    }
  };
  return project;
}
